<template>
  <div :class="bem()">
    <div :class="bem('icon')">
      <VisionIcon id="guarantee-convincer" icon="lifetimeguarantee" size="stretch" gradient="default"/>
    </div>
    <span :class="bem('text')">Guaranteed <span :class="bem('highlight')">For Life</span></span>
    <button :class="bem('tooltip')" @click="handleClick">
      ?
    </button>
  </div>
</template>

<script setup>
const bem = useBEM('GuaranteeConvincer')

const sidebarStore = useSidebarStore()

function handleClick() {
  sidebarStore.setActiveSidebar('lifetime-guarantee')
}
</script>

<style lang="postcss" scoped>
.GuaranteeConvincer {
  @apply flex items-center gap-x-2
    w-full;
}

.GuaranteeConvincer__icon {
  @apply w-5 h-5 lg:w-6 lg:h-6 flex justify-center lgMax:mx-[2px];
}

.GuaranteeConvincer__tooltip {
  @apply ml-auto;
}

.GuaranteeConvincer__text {
  @apply text-sm font-medium;
}

.GuaranteeConvincer__highlight {
  @apply t-gradient;
}

.GuaranteeConvincer__tooltip {
  @apply rounded-full bg-gradient aspect-square text-white text-xxs font-bold flex items-center justify-center h-4 leading-none;
}
</style>